import React, { createContext, use } from 'react';
import {
  getHeaderColor,
  getLinkColor,
  getLinkHoverColor,
  getAccentColor,
  getAccentHoverColor,
  getIconColor,
  getButtonColor,
  getButtonHoverColor,
  getBackgroundColor,
  getBackgroundAltColor,
  getLinkStrongColor,
  getAccentStrongColor,
  getAccentStrongHoverColor
} from '../utils/themeUtils';

const ThemeContext = createContext();

// Colors come from a static palette (see themeUtils.js) with no props/state
// input, so this is safe to compute once at module load instead of per render.
const themeValue = {
  // Color getters
  getHeaderColor,
  getLinkColor,
  getLinkHoverColor,
  getAccentColor,
  getAccentHoverColor,
  getIconColor,
  getButtonColor,
  getButtonHoverColor,
  getBackgroundColor,
  getBackgroundAltColor,

  // Direct color values for inline styles
  headerColor: getHeaderColor(),
  linkColor: getLinkColor(),
  linkStrongColor: getLinkStrongColor(),
  accentStrongColor: getAccentStrongColor(),
  accentStrongHoverColor: getAccentStrongHoverColor(),
  linkHoverColor: getLinkHoverColor(),
  accentColor: getAccentColor(),
  accentHoverColor: getAccentHoverColor(),
  iconColor: getIconColor(),
  buttonColor: getButtonColor(),
  buttonHoverColor: getButtonHoverColor(),
  backgroundColor: getBackgroundColor(),
  backgroundAltColor: getBackgroundAltColor(),
};

export const useTheme = () => {
  const context = use(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  return (
    <ThemeContext.Provider value={themeValue}>
      {children}
    </ThemeContext.Provider>
  );
};

